import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(0); // Open the first one by default

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleFAQ = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null); // Close if clicked again
    } else {
      setActiveIndex(index); // Open clicked
    }
  };

  const faqData = [
    {
      question: "1. What is Wall Street Finz?",
      answer: "Wall Street Finz is a financial service provider that helps individuals access easy, fast, and transparent loan solutions. We guide you through the loan process, connect you with the best lenders, and ensure you receive the most suitable financial option."
    },
    {
      question: "2. What types of loans do you offer?",
      answer: (
        <>
          <p>We offer a wide range of loan services to suit various needs:</p>
          <ul className="faq-list">
            <li>Pay Loan</li>
            <li>Short Term Loan</li>
            <li>Employer-Based Payday Loan</li>
            <li>Cash Advance Loan</li>
          </ul>
        </>
      )
    },
    {
      question: "3. Who can apply for a loan?",
      answer: "Any salaried, self-employed, or business owner with a stable income can apply. Loan eligibility depends on income, credit score, employment stability, and financial history."
    },
    {
      question: "4. How quickly can I get a loan approved?",
      answer: "Approval timelines vary by loan type and documents, but most customers receive approval within 24–48 hours, and some loans are approved even faster."
    },
    {
      question: "5. Is the loan process complicated?",
      answer: (
        <>
          <p>Not at all. Wall Street Finz makes the process extremely simple:</p>
          <ol className="faq-steps">
            <li>Share your requirement</li>
            <li>Submit minimal documents</li>
            <li>Get personalized loan options</li>
            <li>Receive fast approval and disbursement</li>
          </ol>
        </>
      )
    },
    {
      question: "6. Do I need a high credit score to apply?",
      answer: "Yes. A good credit score increases approval chances and helps you get better interest rates. However, we also assist customers with moderate credit scores by finding the best possible loan options."
    },
    {
      question: "7. Are there any hidden charges?",
      answer: "No. We maintain complete transparency. All charges—if any—are explained upfront before you apply."
    },
    {
      question: "8. Does Wall Street Finz provide loans directly?",
      answer: "We are financial facilitators, not a bank. We help you connect with trusted lenders, banks, and NBFCs and assist you throughout the entire loan process."
    },
    {
      question: "9. What documents are required to apply for a loan?",
      answer: (
        <>
          <p>Document requirements vary, but generally include:</p>
          <ul className="faq-list">
            <li>ID Proof & Address Proof</li>
            <li>PAN Card</li>
            <li>Bank Statements</li>
            <li>Salary Slips / ITR (depending on profile)</li>
          </ul>
          <p className="mt-2">Our team will guide you based on your loan type.</p>
        </>
      )
    },
    {
      question: "10. How do I know which loan is right for me?",
      answer: "Our financial experts evaluate your needs, income, credit score, and future goals to recommend the best loan with the lowest possible interest."
    },
    {
      question: "11. Is my information safe with Wall Street Finz?",
      answer: "Yes. We follow strict data privacy standards. Your details are secure and shared only with relevant banks/NBFCs after your consent."
    },
    {
      question: "12. How can I contact Wall Street Finz?",
      answer: (
        <div className="faq-contact-info">
          <p>You can reach us through:</p>
          <ul>
            <li><strong>Website:</strong> <a href="https://www.wallstreetfinz.com">www.wallstreetfinz.com</a></li>
            <li><strong>Call:</strong> <a href="tel:9911998997">9911998997</a></li>
            <li><strong>Email:</strong> <a href="mailto:Info@Wallstreetfinz.com">Info@Wallstreetfinz.com</a></li>
          </ul>
          <p className="mt-2">Our support team is available to assist you throughout your loan journey.</p>
        </div>
      )
    },
    {
      question: "13. Do you assist with low-interest and long-tenure loans?",
      answer: "Absolutely. We help customers secure the most suitable interest rates and flexible repayment plans based on their profile."
    },
    {
      question: "14. What makes Wall Street Finz different?",
      answer: (
        <ul className="faq-check-list">
          <li>Simple & quick loan process</li>
          <li>100% transparency</li>
          <li>Personalized guidance</li>
          <li>Fast approvals</li>
          <li>Trusted lender partnerships</li>
        </ul>
      )
    }
  ];
  return (
    <>
      {/* Custom Cursors */}
      <div className="custom-cursor-one"></div>
      <div className="custom-cursor-two"></div>

      {/* inner-page hero start */}
      <div 
        className="inner-page-hero" 
        style={{ backgroundImage: 'url(/assets/images/background/bg3.png)' }}
      >
        <div className="container">
          <div className="hero-heading-title">
            <h2>FAQ</h2>
          </div>
          <ul className="bradcrumb">
            <li><a href="/">Home</a></li>
            <li><Link to="#">FAQ</Link></li>
          </ul>
        </div>
      </div>
      {/* inner-page hero end */}

      {/* --- FAQ SECTION --- */}
      <section className="faq-section">
        <div className="container">
          <div className="row justify-content-center">
            
            {/* Header Text */}
            <div className=" mb-5 text-center">
            <span className="heading-subtitle wow fadeInUp animated">⭐ HAVE QUESTIONS?</span>
            <h2 className="wow fadeInUp animated">We have answers to your financial queries</h2>
            </div>

            {/* Accordion Container */}
            <div className="col-lg-12">
              <div className="faq-wrapper">
                
                {faqData.map((item, index) => (
                  <div 
                    key={index} 
                    className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                  >
                    <div 
                      className="faq-header" 
                      onClick={() => toggleFAQ(index)}
                    >
                      <h4 className="faq-question">{item.question}</h4>
                      <span className="faq-icon">
                        {activeIndex === index ? '−' : '+'}
                      </span>
                    </div>
                    
                    <div 
                      className="faq-body" 
                      style={{ 
                        maxHeight: activeIndex === index ? '500px' : '0px'
                      }}
                    >
                      <div className="faq-content">
                        {item.answer}
                      </div>
                    </div>
                  </div>
                ))}

              </div>
            </div>

            {/* Still have questions box */}
            <div className="col-lg-10 mt-5">
              <div className="faq-contact-box">
                <h3>Still have questions?</h3>
                <p>Can't find the answer you're looking for? Please chat to our friendly team.</p>
                <Link to="/contact" className="btn btn-primary btn-faq-custom">Contact Us</Link>
              </div>
            </div>

          </div>
        </div>
      </section>


    </>
  );
};

export default Faq;